import * as Sentry from '@sentry/react-native';

import { END_SENTRY_TRANSACTION, START_SENTRY_TRANSACTION } from './constants';

export function startSentryTransaction(transactionName: string) {
    const transaction = Sentry?.startInactiveSpan({
        name: transactionName,
        forceTransaction: true,
    });
    return {
        type: START_SENTRY_TRANSACTION,
        payload: { transactionName, transaction },
    };
}

export function endSentryTransaction(transactionName: string) {
    return {
        type: END_SENTRY_TRANSACTION,
        payload: { transactionName },
    };
}
